import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import SidebarComponent from '../common/sidebar-component';
import ContributorResultsContext from './context';
import SidebarComponentHeader from '../common/sidebar/sidebar-component-header';
import StockCode from '../common/sidebar/stock-code';
import useGetStockCodesUsedByContributor from '../../../services/stock-codes/stocks-used-by-contributor-service';

export default function TopStockCodes({ profile }) {
  const { dispatch } = React.useContext(ContributorResultsContext);
  const [{ data }, executeQuery] = useGetStockCodesUsedByContributor(profile.id, 5);

  React.useEffect(() => {
    executeQuery();
  }, [executeQuery]);

  React.useEffect(() => {
    if (_.get(data, 'stockCodes.length')) {
      dispatch({ type: 'setStockCodes', payload: data.stockCodes });
    }
  }, [data, dispatch]);

  if (!_.get(data, 'stockCodes.length')) {
    return null;
  }

  return (
    <SidebarComponent>
      <SidebarComponentHeader
        title={`${data.stockCodes.length > 1 ? 'companies' : 'company'} mentioned by`}
        query={profile.name}
      />
      {data.stockCodes.map(d => <StockCode key={`stock-code-${d.id}`} stockCode={d} />)}
    </SidebarComponent>
  );
}

TopStockCodes.propTypes = {
  profile: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
};
